<div class="login-container">
  <div class="login-card">

    <img src="assets/img/gma_tipografia.png" alt="GMA" class="login-logo" />
    <p class="login-subtitle">Acesse sua conta</p>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="container-form">
      <div class="field">
        <p-floatlabel variant="on">
          <input pInputText id="login" formControlName="login" [class.ng-invalid]="isInvalid('login')"
            [class.ng-dirty]="isInvalid('login')" />
            <label for="login">Login</label>
          </p-floatlabel>
          @if (isInvalid('login')) {
            <small class="field-error">Login obrigatório</small>
          }
        </div>

        <div class="field">
          <p-floatlabel variant="on">
            <input pInputText id="senha" type="password" formControlName="senha" [class.ng-invalid]="isInvalid('senha')"
              [class.ng-dirty]="isInvalid('senha')" />
              <label for="senha">Senha</label>
            </p-floatlabel>
            @if (isInvalid('senha')) {
              <small class="field-error">Senha obrigatória</small>
            }
            <div class="forgot-password">
              <a [routerLink]="['/esqueci-senha']" class="register-link">Esqueci minha senha</a>
            </div>
          </div>

          @if (mensagemSessao) {
            <div class="login-error">
              {{ mensagemSessao }}
            </div>
          }

          @if (erroLogin) {
            <div class="login-error">
              Login ou senha inválidos.
            </div>
          }

          <div class="btn-field">
            <p-button class="btn-entrar" type="submit" label="Entrar" [loading]="loading" />
          </div>

        </form>

        <div class="register-request">
          <span>Não tem uma conta?</span>
          <a [routerLink]="['/solicitar-cadastro']" class="register-link">Solicitar cadastro</a>
        </div>

      </div>
    </div>